import { Box, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";
import "./sellerlevel.css";

export default function SellerLevel() {
  return (
    <Flex gap={{ base: 5, lg: 10 }} my={5}>
      <Stack w={{ base: "60%", md: "30%" }}>
        <Heading
          fontSize={{ base: "14px", md: "24px" }}
          fontWeight={"semibold"}
        >
          Your Seller Level
        </Heading>
        <Text color="#676767" fontSize={{ base: "12px", md: "16 px" }}>
          Evaluation period ends on 15 Aug 2022, 00:00 GMT
        </Text>
        <Text
          cursor="pointer"
          color="brand.500"
          fontSize={{ base: "12px", md: "16 px" }}
        >
          Learn More
        </Text>
      </Stack>
      <Box width={{ md: "70%" }} display={{ base: "none", md: "block" }}>
        <div className="progressbar-wrapper">
          <ul className="progressbar">
            <li>Level Zero</li>
            <li>Level One</li>
            <li>Level Two</li>
            <li>Top Rated</li>
          </ul>
        </div>
      </Box>
      <Box display={{ base: "block", md: "none" }} pr={8} position="relative">
        <div className="progressbar-wrapper-mobile">
          <ul className="progressbar-mobile">
            <li>
              <p>Level Zero</p>
            </li>
            <li>
              <p>Level One</p>
            </li>
            <li>
              <p>Level Two</p>
            </li>
            <li>
              <p>Top Rated</p>
            </li>
          </ul>
        </div>
      </Box>
    </Flex>
  );
}
